import { useCallback, useEffect, useState } from 'react';
import type { ColumnType } from 'antd/lib/table';
import type { Key } from 'react';
import type { AppTableSingleColumn } from 'shared/UI/UIKit/Table';

const CONTROLS_KEY = 'controls';

export const useTableColumnsFilter = (
  columns: ColumnType<any>[],
  onColumnsChange: (columns: ColumnType<any>[]) => void,
  hiddenByDefaultKeys?: string[],
) => {
  const [visibleKeys, setVisibleKeys] = useState<Key[]>(() =>
    columns
      .map((column) => (column as AppTableSingleColumn<any>).key)
      .filter((key) => !hiddenByDefaultKeys?.includes(String(key))),
  );

  const options = columns
    .filter((column) => (column as AppTableSingleColumn<any>).key !== CONTROLS_KEY)
    .map((column) => ({
      label: (column as AppTableSingleColumn<any>).title as string,
      value: (column as AppTableSingleColumn<any>).key,
    }));

  const handleChange = useCallback((value: Key[]) => {
    setVisibleKeys([...value, CONTROLS_KEY]);
  }, []);

  useEffect(() => {
    const filtered = columns.filter((column) =>
      visibleKeys.includes((column as AppTableSingleColumn<any>).key),
    );
    onColumnsChange(filtered);
  }, [visibleKeys]);

  return {
    state: {
      visibleKeys,
      options,
    },
    methods: {
      handleChange,
    },
  };
};
